import { Typeahead } from "react-bootstrap-typeahead";
import { Col, Label, Row } from "reactstrap";
import { P } from "../../../../../../AbstractElements";
import { productTagItem } from "../../../../../../Data/AppsData/EcommerceData/ProductData";
import { ProductTagProp } from "../../../../../../Types/EcommerceType";

export default function ProductTag({ title, subTitle }: ProductTagProp) {
  return (
    <Col sm={6}>
      <Row className="g-2 product-tag">
        <Col xs={12}>
          <Label className="d-block m-0">{title}</Label>
        </Col>
        <Col xs={12}>
          <Typeahead id="multiple-typeahead" labelKey="name" options={productTagItem} multiple clearButton defaultSelected={["watches", "sports"]} />
          {subTitle && <P className="f-light">{"Products can be tagged"}</P>}
        </Col>
      </Row>
    </Col>
  );
}
